import { ColumnDef } from '@tanstack/react-table'
import { Button } from '@/common/ui/button'
import { Badge } from '@/common/ui/badge'
import { ExternalLink } from 'lucide-react'
import { Link } from 'react-router-dom'
import { PlayerWithTagsModel, PlayerTagResponse } from '../../types'
import AssignPlayerTagsModal from '@/modules/manage-player/components/GetPlayerList/components/GetPlayerListTable/CellAction/components/AssignPlayerTagsModal'
import { PhoneCell } from '@/common/components/PhoneCell'
import { UsernameCell } from '@/common/components/UsernameCell'

export const createColumns = (
	hasWritePermission: boolean,
): ColumnDef<PlayerWithTagsModel>[] => [
	{
		accessorKey: 'username',
		header: 'ชื่อผู้ใช้',
		cell: ({ row }) => (
			<UsernameCell
				username={
					(row.original as Record<string, unknown>).username as string | null
				}
			/>
		),
	},
	{
		accessorKey: 'phone',
		header: 'เบอร์โทรศัพท์',
		cell: ({ row }) => (
			<PhoneCell playerId={row.original.id} phone={row.original.phone} />
		),
	},
	{
		accessorKey: 'tags',
		header: 'แท็ก',
		cell: ({ row }) => (
			<div className="flex flex-wrap gap-1">
				{row.original.tags.map((tag) => (
					<div key={tag.id} className="flex flex-col gap-1">
						<Badge
							variant="outline"
							style={{ backgroundColor: tag.color || '#e5e7eb' }}
							className="text-xs text-white"
						>
							{tag.name}
						</Badge>
					</div>
				))}
				{row.original.tags.length === 0 && (
					<span className="text-sm text-muted-foreground">ไม่มีแท็ก</span>
				)}
			</div>
		),
	},
	{
		accessorKey: 'totalDepositAmount',
		header: 'ยอดฝากรวม',
		cell: ({ row }) => (
			<div>
				฿{row.original.totalDepositAmount?.toLocaleString('th-TH') || '0'}
			</div>
		),
	},

	{
		id: 'viewDetail',
		header: 'ดูข้อมูล',
		cell: ({ row }) => (
			<Link to={`/operator/get-player-list/player-detail/${row.original.id}`}>
				<Button variant="outline" size="sm">
					<ExternalLink className="mr-2 h-4 w-4" />
					ดูข้อมูล
				</Button>
			</Link>
		),
	},
	{
		id: 'actions',
		header: 'การดำเนินการ',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				{hasWritePermission && (
					<AssignPlayerTagsModal
						playerId={row.original.id}
						playerPhone={row.original.phone}
						currentTags={row.original.tags as PlayerTagResponse[]}
					/>
				)}
			</div>
		),
	},
]
